const HIDDEN_DOCTOR_CONTACT_ICONS = new Set(["email", "phone"]);

export function filterDoctorContactList(contactList) {
  if (!contactList || !contactList.length) {
    return [];
  }
  return contactList.filter((item) => !HIDDEN_DOCTOR_CONTACT_ICONS.has(item.icon));
}
